import { get } from 'lodash-es';

/**
 * This requires the use of ng-bind-html
 * <span ng-bind-html="$ctrl.origText | aptHighlight:$ctrl.stringToHighlight"
 * I originally intended to make this a directive or component but that turned out to be troublesome when using with the grid at least
 * so this turned out to be simpler and less code
 */
export default abstract class HeaderDetailsBaseService {
  dateFormat: string = 'MM/DD/YY';

  constructor(private _data = {}) {
    //
  }

  // this is the type of the data set e.g. 'rfp' or 'contract' not the type of RFP
  abstract get dataType(): string;

  abstract get typeDescription(): string;

  get data(): any {
    return this._data || {};
  }

  // All of the following tend to check multiple locations for the same data.
  get id() {
    return this.data.id;
  }

  get type() {
    return this.data.type || this.data.rfpType;
  }

  get isGroupRfp() {
    return (
      this.data.groupRfp || this.data.isGroupRequest || this.data.isGroupRfp
    );
  }

  get buyerName() {
    let buyer = get(this.data, 'buyer', { name: '' });

    return buyer.name;
  }

  get categoryName() {
    return this.data.category.name;
  }
}
